import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PriceItemProps } from '@entities/order';
import { getSelectedInsurances } from '../../../../Checkout/store/order/selectors';

export const useRefundInsurancePrices = () => {
	const selectedInsurances = useSelector(getSelectedInsurances);

	const insurancePrices = useMemo(() => {
		const insurancePrices: PriceItemProps[] = [];
		const addedInsuranceNames = new Set<string>();

		selectedInsurances.forEach(insurance => {
			const { insuranceProgram, policyUrl } = insurance;
			const insuranceName = insuranceProgram.name;

			if (!policyUrl || addedInsuranceNames.has(insuranceName)) {
				return;
			}

			addedInsuranceNames.add(insuranceName);

			insurancePrices.push({
				name: `${insuranceProgram.name}*`,
				price: insuranceProgram.totalPrice
			});
		});

		return insurancePrices;
	}, [selectedInsurances]);

	return insurancePrices;
};
